import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity } from '../../helpers/helpers';

// Translations
import translate from '../Translate.js';

// Components
import Address from '../Map/Address';

const PaymentForm = observer(class PaymentForm extends React.Component {
  constructor() {
    super();
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    this.props.store.PaymentStore.location = {}

    this.state = {
      password: null,
      complete: false
    }
  }

  componentWillUnmount() {
    this.props.store.PaymentStore.resetPaymentData();
    this.props.store.PaymentStore.getBalance(true);
    this.props.parent.setState({
      collect: false,
      paymentType: null
    })
  }

  handleInput() {
    const location = {
      address1: this.address1.value,
      address2: this.address2.value,
      place: this.place.value,
      region: this.region.value,
      country: this.country.value,
      postalCode: this.postalCode.value
    }

    this.props.store.PaymentStore.location = location;

    if(this.password) {
      this.setState({
        password: this.password.value
      });
    }
  }

  handleSubmit() {
    // const { errorMsg } = this.props.translation;

    this.props.store.PaymentStore.createPayment(this.complete);

    // this.props.store.PaymentStore.validatePayment(this.state.password, errorMsg, this.complete);
  }

  complete() {
    this.setState({
      complete: true
    });
  }

  render() {
    const { translation } = this.props;
    const { PaymentStore } = this.props.store;
    const { checkUrl, location, paymentData } = PaymentStore;
    const paymentType = PaymentStore.paymentData.type;

    if(!this.state.complete) {
      return (
        <div className="drawer__content wrap">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <form className="panel--medium" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
            <h2 className="panel__subhdg">
              {paymentType === 'physical-check' &&
                translation.sub_heading
              }

              {paymentType === 'online-check' &&
                translation.sub_heading_print
              }
            </h2>

            <fieldset>
              <ul className="fields fields--alt">
                <li>
                  <label className="lbl-required" htmlFor="payto">{translation.pay_to}</label>

                  <input
                    type="text"
                    id="payto"
                    defaultValue={paymentData.payTo || ''}
                    placeholder={translation.pay_to}
                    onChange={() => paymentData.payTo = this.payTo.value}
                    ref={(input) => {this.payTo = input}}
                    required
                    aria-required="true"
                  />
                </li>
              </ul>
            </fieldset>

            {!location.address1 &&
              <fieldset>
                <ul className="fields">
                  <li>
                    <Address
                      locationParent={this.props.store.PaymentStore}
                      mailing={true}
                      {...this.props}
                    />
                  </li>
                </ul>
              </fieldset>
            }

            {location.address1 &&
              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="lbl-required" htmlFor="map-addr1">{translation.address1}</label>

                    <input
                      type="text"
                      id="map-addr1"
                      defaultValue={location.address1 || ''}
                      placeholder={translation.address1}
                      onChange={this.handleInput}
                      ref={(input) => {this.address1 = input}}
                      required
                      aria-required="true"
                    />

                    <label className="meta" htmlFor="map-addr2">{translation.address2}</label>

                    <input
                      type="text"
                      id="map-addr2"
                      defaultValue={location.address2 || ''}
                      placeholder={translation.address2}
                      onChange={this.handleInput}
                      ref={(input) => {this.address2 = input}}
                    />
                  </li>
                  <li>
                    <label className="lbl-required" htmlFor="map-city">{translation.city}</label>

                    <input
                      type="text"
                      id="map-city"
                      defaultValue={location.place || ''}
                      placeholder={translation.place}
                      onChange={this.handleInput}
                      ref={(input) => {this.place = input}}
                    />
                  </li>
                  <li className="field--third">
                    <label className="lbl-required" htmlFor="map-region">{translation.region}</label>

                    <input
                      type="text"
                      id="map-region"
                      defaultValue={location.region || ''}
                      placeholder={translation.region}
                      onChange={this.handleInput}
                      ref={(input) => {this.region = input}}
                    />
                  </li>
                  <li className="field--third">
                    <label className="lbl-required" htmlFor="map-postal">{translation.zip}</label>

                    <input
                      type="text"
                      id="map-postal"
                      defaultValue={location.postalCode || ''}
                      placeholder={translation.zip}
                      onChange={this.handleInput}
                      ref={(input) => {this.postalCode = input}}
                    />
                  </li>
                  <li className="field--third">
                    <label className="lbl-required" htmlFor="map-country">{translation.country}</label>

                    <input
                      type="text"
                      id="map-country"
                      defaultValue={location.country || ''}
                      placeholder={translation.country}
                      onChange={this.handleInput}
                      ref={(input) => {this.country = input}}
                    />
                  </li>
                  {/* <li>
                    <label className="lbl-required" htmlFor="payment-password"  aria-describedby="password-tooltip">
                      {translation.password.label}

                      <div className="tooltip">
                        <span className="tooltip__label">(?)</span>
                        <div id="password-tooltip" className="tooltip__body" role="tooltip">
                          {translation.password.tooltip}
                        </div>
                      </div>
                    </label>

                    <input
                      id="payment-password"
                      type="password"
                      placeholder={translation.password.helper}
                      ref={(input) => {this.password = input}}
                      onChange={this.handleInput}
                      required
                      aria-required="true"
                    />
                  </li> */}
                </ul>
              </fieldset>
            }

            <div className="panel__actions actions">
              <button
                className="actions__btn actions__btn--primary"
                // disabled={!location.address1 || !this.state.password}
                disabled={!location.address1}
              >
                {translation.button}
              </button>
            </div>
          </form>
        </div>
      );
    } else {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          {paymentType === 'physical-check' &&
            <div className="panel--brief">
              <h2 className="panel__title">{translation.success.physical.heading}</h2>

              <p>{translation.success.physical.body}</p>
            </div>
          }

          {paymentType === 'online-check' &&
            <div className="panel--brief">
              <h2 className="panel__title">{translation.success.online.heading}</h2>

              <p>{translation.success.online.body}</p>

              <a className="btn" href={checkUrl} target="_blank">{translation.success.online.button}</a>
            </div>
          }
        </div>
      )
    }
  }
})

export default translate('PaymentForm')(PaymentForm);



// WEBPACK FOOTER //
// ./src/app/components/Payments/PaymentForm.js